import { Component } from '@angular/core';
import { Tabs, TabList } from 'primeng/tabs';
import { PaInfoBlockComponent } from 'src/app/shared/ui-kit/pa-info-block/pa-info-block.component';
import { PaRouterTabsComponent } from 'src/app/shared/ui-kit/pa-router-tabs/pa-router-tabs.component';
import { PaTabComponent } from 'src/app/shared/ui-kit/pa-tab/pa-tab.component';

@Component({
  selector: 'app-tab-view',
  standalone: true,
  imports: [
    Tabs,
    TabList,
    PaTabComponent,
    PaRouterTabsComponent,
    PaInfoBlockComponent,
  ],
  templateUrl: './tab-view.component.html',
  styleUrls: ['./tab-view.component.scss'],
})
export class TabViewComponent {
  activeTab1: string = 'tab1';
  activeTab2: string = 'tab1';
  activeTab3: string = 'tab1';
  activeTab4: string = 'tab1';
  activeTab5: string = 'tab1';
  activeTab6: string = 'tab1';
  activeTab7: string = 'tab1';

  badgeValue = 5;
  loadingValue = false;

  toggleLoading(): void {
    this.loadingValue = !this.loadingValue;
  }

  handleTabChange1(value: string | number): void {
    this.activeTab1 = String(value);
  }

  handleTabChange2(value: string | number): void {
    this.activeTab2 = String(value);
  }

  handleTabChange3(value: string | number): void {
    this.activeTab3 = String(value);
  }

  handleTabChange4(value: string | number): void {
    this.activeTab4 = String(value);
  }

  handleTabChange5(value: string | number): void {
    this.activeTab5 = String(value);
  }

  handleTabChange6(value: string | number): void {
    this.activeTab6 = String(value);
  }

  handleTabChange7(value: string | number): void {
    this.activeTab7 = String(value);
  }
}
